module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1020-1f172c7f16867ac86e1a12a8bbcefd16.png";